module.exports = __webpack_public_path__ + "static/media/git.12791bf6.png";